import { HStack } from '@chakra-ui/react';
import {
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Button,
} from 'components/v4';

export default function DeleteConfirmationModal({
    onClose,
    isOpen,
    registrarName,
    onConfirm,
    isDeleting = false,
}) {
    const handleConfirm = () => {
        onConfirm();
    };

    return (
        <Modal
            closeOnOverlayClick={false}
            isCentered
            isOpen={isOpen}
            onClose={onClose}
            size="md">
            <ModalOverlay backdropFilter="blur(10px)" />
            <ModalContent>
                <ModalHeader>Delete Registrar</ModalHeader>
                <ModalBody>
                    <p className="text-base">
                        {`Are you sure you want to delete "${registrarName}"? This action cannot be undone.`}
                    </p>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={3}>
                        <Button
                            variant="outline"
                            onClick={onClose}
                            isDisabled={isDeleting}>
                            Cancel
                        </Button>
                        <Button
                            colorScheme="red"
                            onClick={handleConfirm}
                            isLoading={isDeleting}
                            loadingText="Deleting...">
                            Delete
                        </Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
